export const ADMINISTRATION_ACTION_TYPES = {
  LOAD_ROLES: 'administration/LOAD_ROLES',
  CREATE_ROLE: 'administration/CREATE_ROLE',
  EDIT_ROLE: 'administration/EDIT_ROLE',
  DELETE_ROLE: 'administration/DELETE_ROLE',
  LOAD_PLAIN_ROLES: 'administration/LOAD_PLAIN_ROLES',
  LOAD_ADMINS: 'administration/LOAD_ADMINS',
  CREATE_ADMIN: 'administration/CREATE_ADMIN',
  EDIT_ADMIN: 'administration/EDIT_ADMIN',
  DELETE_ADMIN: 'administration/DELETE_ADMIN',
};

export function loadRoles(payload) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: ADMINISTRATION_ACTION_TYPES.LOAD_ROLES,
        payload,
        resolve,
        reject,
      })
    })
  }
}

export function loadPlainRoles() {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: ADMINISTRATION_ACTION_TYPES.LOAD_PLAIN_ROLES,
        resolve,
        reject,
      })
    })
  }
}

export function createRole(payload) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: ADMINISTRATION_ACTION_TYPES.CREATE_ROLE,
        payload,
        resolve,
        reject,
      })
    })
  }
}

export function editRole(payload) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: ADMINISTRATION_ACTION_TYPES.EDIT_ROLE,
        payload,
        resolve,
        reject,
      })
    })
  }
}

export function deleteRole(payload) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: ADMINISTRATION_ACTION_TYPES.DELETE_ROLE,
        payload,
        resolve,
        reject,
      })
    })
  }
}

export function loadAdmins(payload) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: ADMINISTRATION_ACTION_TYPES.LOAD_ADMINS,
        payload,
        resolve,
        reject,
      })
    })
  }
}

export function createAdmin(payload) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: ADMINISTRATION_ACTION_TYPES.CREATE_ADMIN,
        payload,
        resolve,
        reject,
      })
    })
  }
}

export function editAdmin(payload) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: ADMINISTRATION_ACTION_TYPES.EDIT_ADMIN,
        payload,
        resolve,
        reject,
      })
    })
  }
}

export function deleteAdmin(payload) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: ADMINISTRATION_ACTION_TYPES.DELETE_ADMIN,
        payload,
        resolve,
        reject,
      })
    })
  }
}
